/// <reference path="../../typings/tsd.d.ts" />
module warsApp.services {


    export class SystemCodeService extends services.DataService<Wars.Domain.Model.Codes.SystemCode> {


        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getSystemCode(id: string): ng.IPromise<Wars.Domain.Model.Codes.SystemCode> {
            return this.fetchById(id, "SystemCode");
        }

        public getSystemCodesByCodeGroupId(id: string): ng.IPromise<Wars.Domain.Model.Codes.SystemCode[]> {
            const query = this.breezeModule.EntityQuery
                .from("SystemCode")
                .where("parentCodeGroup_id", "==", id);

            return this.executeQuery(query);
        }
    }
}

warsApp.registerService('SystemCodeService', ['breeze', '$q']);